module.exports = __webpack_public_path__ + "static/Award2-4993c9338fdb96d7e0b46e5709c74615.jpg";